import iconPlus from 'assets/img/svg/plus.svg'
import iconMinus from 'assets/img/svg/minus.svg'
import mediasMixins from 'root/mixins/mediasMixin.js'
import closeImage from 'assets/img/svg/close.svg'

export default {
  name: 'product-refinement',
  props:['searchpagedata'],
  data () {
    return {
  
    }
  },

  methods: {
  
  },

  computed: {
    showAppliedFilters() {
      return _.get(this, '$root.searchPageData.breadcrumbs.length', 0) > 0
    },
    
    searchPageData() {
      return JSON.parse(this.searchpagedata)
    }
  },

  mounted: function () {
  },

  watch: {
  }
}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/productrefinement/productrefinement.js